<template>
  <modal
    ref="examsModalAlert"
    template="neutral"
    title="Aviso"
    ref-name="examsModalAlert"
    first-button-text="CONCLUIR"
    :icon-enabled="false"
    :close-button-enabled="false"
    class="exams-modal-alert"
    @first-cta="closeModal()"
  >
    <div class="modal-container">
      <div class="content">
        <div class="img-wrapper">
          <img
            src="/static/images/icon-alert-modal.svg"
            alt="icone-alerta"
          >
        </div>
        <span v-if="code === 'HIV4C'">
          Para realização do exame <b>HIV4C</b> é necessário o envio em tubo primário: <b>TUBO SORO GEL SEPARADOR</b>.
        </span>
        <span v-if="code === 'PDST'">
          Para o exame PDST <b class="red">NÃO</b> utilizar o frasco Digene, pois o mesmo prejudica a qualidade da
          amostra obtida na coleta.
        </span>
        <span v-if="code === 'PSA'">
          Para o exame de PSA, em caso de pacientes cadastrados com sexo <b>FEMININO</b>, não será liberado o resultado
          de <b>PSALIVRE</b>.
        </span>
        <span v-if="code === 'PATMATER' || code === 'PAT' || code === 'PATDUO' || code === 'PATRECONS'">
          Para os exames de Paternidade <b style="color: #7f1a54">[PATMATER; PAT; PATDUO; PATRECONS]</b>, confira todos
          os itens no documento
          <b style="color: #7f1a54">POD09224 - Check List e Boas Práticas Paternidade e Maternidade</b>. Se todos os
          itens não forem enviados corretamente, o exame não será executado.
        </span>
      </div>
      <button
        class="highlight"
        @click="closeModal"
      >
        OK
      </button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ExamsAlertModal',
  data: () => ({
    code: null
  }),
  methods: {
    openModal(code) {
      this.code = code
      this.$refs.examsModalAlert.open()
    },
    closeModal() {
      this.$refs.examsModalAlert.close()
    }
  }
}
</script>

<style lang="scss">
.exams-modal-alert {
  .standard-modal__title {
    &:before {
      content: '';
      display: inline-block;
      width: 17px;
      height: 16px;
      background-image: url('/static/images/icon-alert-modal.svg');
      margin-right: 9px;
      position: relative;
      top: 2px;
    }
  }
  .modal-container {
    text-align: center;
    .content {
      text-align: left;
      color: #4a4a4a;
      font-size: 14px;
      padding: 13px 12px 12px;
      background-color: #fdedd3;
      max-width: 420px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      border-radius: 5px;
      .img-wrapper {
        width: 32px;
      }
      span {
        letter-spacing: 0;
        color: #4a4a4a;
        font-size: 14px;
        width: calc(100% - 32px);
      }

      .red {
        color: #e2245a;
      }
    }
    .highlight {
      background-color: #7f1a54;
      height: auto;
      padding: 12px 60px;
      font-size: 12px;
      letter-spacing: 1px;
      border-radius: 3px;
      margin: 30px auto 5px;
    }
  }
}
</style>
